import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import NoData from '../../../components/common/NoData';
import Loader from '../../../components/common/Loader';
import { useTimezone } from '../../../context/TimezoneContext';
import { formatUtcInTimeZone } from '../../../utils/timezone';

function RecentPushedAnnouncement({ announcements = [], loading = false, canViewModule = false }) {
  const { timeZone } = useTimezone();

  return (
    <div className="tw-flex tw-min-h-[500px] tw-min-w-0 tw-flex-col tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 tw-shadow-sm">
      <div className="tw-mb-4 tw-flex tw-items-center tw-justify-between tw-gap-3">
        <h5 className="tw-mb-0">Recent Announcements</h5>
        {canViewModule && (
          <Link
            to="/admin/settings?activeTab=announcement"
            className="tw-shrink-0 tw-text-sm tw-font-medium tw-text-[#3152e8] hover:tw-underline"
            aria-label="View all announcements"
          >
            View all
          </Link>
        )}
      </div>
      {loading ? (
        <div className="tw-flex tw-min-h-[400px] tw-items-center tw-justify-center">
          <Loader />
        </div>
      ) : announcements.length === 0 ? (
        <div className="tw-flex tw-min-h-[400px] tw-items-center tw-justify-center">
          <NoData
            message="No recent announcements"
            description="Announcements will appear here after they are published."
            icon="fluent:megaphone-24-regular"
          />
        </div>
      ) : (
        <div className="tw-max-h-[400px] tw-min-w-0 tw-space-y-3 tw-overflow-y-auto">
          {announcements.map((item, index) => (
            <article
              key={item.id || item._id || index}
              className="tw-relative tw-min-w-0 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-p-4 tw-pl-5"
            >
              <span aria-hidden="true" className="tw-absolute tw-inset-y-0 tw-left-0 tw-w-1 tw-bg-brand-600" />
              <h6 className="tw-mb-1 tw-truncate tw-text-sm tw-font-semibold tw-leading-5 tw-text-slate-900" title={item.title || 'Announcement'}>{item.title || 'Announcement'}</h6>
              {item.createdAt && (
                <time className="!tw-text-[var(--secondary-color)] tw-mb-2 tw-block tw-text-xs tw-text-slate-500" dateTime={item.createdAt}>
                  {formatUtcInTimeZone(item.createdAt, timeZone, 'MMM DD, YYYY')}
                </time>
              )}
              <p className="tw-mb-0 tw-overflow-hidden tw-text-sm tw-leading-5 tw-text-slate-600 [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2] [overflow-wrap:anywhere]" title={item.message || 'No message available.'}>
                {item.message || 'No message available.'}
              </p>
              {item.scheduleDateTime && (
                <div className="!tw-text-[var(--secondary-color)] tw-mt-3 tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-slate-500">
                  <Icon icon="lucide:calendar" aria-hidden="true" />
                  Scheduled: {formatUtcInTimeZone(item.scheduleDateTime, timeZone, 'MMM DD, YYYY h:mm A')}
                </div>
              )}
            </article>
          ))}
        </div>
      )}
    </div>
  );
}

export default RecentPushedAnnouncement;
